// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    grn: []
};

const slice = createSlice({
    name: 'gatein',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // GET DEPARTMENT
        setGRN(state, action) {
            state.grn = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getGRN(queryString = '') {
    return async () => {
        try {
            const response = await axios.get('/grnl');
            dispatch(slice.actions.setGRN(response.data.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
